module.exports = __webpack_public_path__ + "img/Icon-Close-white.966bf160.svg";